import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=52e2e04d"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=52e2e04d&prod&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=52e2e04d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports